import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomSidePanel from "../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../components/button";
import SimpleDropdown from "../../../components/dropdowns/simple-dropdown";
import * as senderIdActions from "../store/actions/sender_id_list_actions";

export default function SenderIdSidePanel({ show, senderIdData, loadingData, handleClose }) {
  const [statusDropdownValue, setStatusDropdownValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    setStatusDropdownValue(senderIdData.status);
  }, [senderIdData]);

  const handleSenderIdStatus = (e) => {
    e.preventDefault();
    const payload = {
      id: senderIdData._id,
      loadingData,
      data: { status: statusDropdownValue },
    };

    dispatch(senderIdActions.editSenderIdRequest(payload));
    handleClose();
  };

  return (
    <CustomSidePanel
      show={show}
      moduleName="Sender Id"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >
      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{"Sender Id"}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <Form onSubmit={handleSenderIdStatus}>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <SimpleDropdown
              value={statusDropdownValue}
              handleSelect={({ value }) => setStatusDropdownValue(value)}
              options={[
                { label: "Approved", value: "approved" },
                { label: "Rejected", value: "rejected" },
              ]}
            />
          </Form.Group>
          <Form.Group className="d-flex gap-3 mt-10">
            <Button size="sm" variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <BlueGradientButton size="sm" type="submit">
              Save
            </BlueGradientButton>
          </Form.Group>
        </Form>
      </div>
    </CustomSidePanel>
  );
}
